import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { MessageCircle, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../../utils/metaPixel';
export function OfferSection() {
  const handleBuyClick = () => {
    trackAddToCart();
    window.location.href = 'https://www.hoypleno.com/cart/44318275534934:1';
  };
  return <section id="comprar" className="py-24 bg-white relative" data-id="element-153">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-154">
        <FadeIn data-id="element-155">
          <div className="text-center mb-16" data-id="element-156">
            <span className="inline-block py-1 px-3 rounded-full bg-[#E8E0D5] text-[#8B7355] text-sm font-medium tracking-wider uppercase mb-6" data-id="element-157">
              Precio de lanzamiento
            </span>
            <p className="text-xl mb-6" data-id="element-158">
              Por lanzamiento, hoy lo puedes obtener por:
            </p>
            <div className="text-6xl md:text-7xl font-bold text-[#8B7355] mb-4 font-serif" data-id="element-159">
              $9.99{' '}
              <span className="text-2xl font-sans font-normal text-[#6B5C4D]" data-id="element-160">
                (PDF)
              </span>
            </div>
            <p className="text-[#6B5C4D] italic mb-4" data-id="element-161">
              (Después vuelve a su precio normal.)
            </p>
            <p className="text-2xl text-[#6B5C4D] line-through mb-8" data-id="element-162">$20.00</p>
            <div className="mt-10" data-id="element-163">
              <Button onClick={handleBuyClick} className="px-10 py-5 text-xl" data-id="element-164">
                Quiero volver a mi centro
              </Button>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}